import React, { memo } from 'react';
import type { IAccordionProps } from '../../types';
import { AccordionLayout } from './AccordionLayout';

export const AccordionSimple: React.FC<IAccordionProps> = memo(props => (
  <AccordionLayout {...props} />
));
